import { InputText } from "primereact/inputtext";
import { FC } from "react";
import Form from "react-bootstrap/Form";
import { isFieldRequired } from "../../helpers/utils";
import CommonFormLabel from "./CommonFormLabel";
interface ICustomInputText {
  controlId?: any;
  label?: any;
  placeholder?: string;
  handleChange?: any;
  handleBlur?: any;
  errorsField?: any;
  touched?: any;
  value?: any;
  inputClassName?: any;
  inputWrapClass?: any;
  inputIcon?: any;
  disabled?: boolean;
  wrapperClassname?: any;
  keyfilter?: any;
  validationSchema?: any;
  tooltip?: any;
  tooltipContent?: any;
  autoComplete?: any;
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; value: any; inputClassName: any; inputWrapClass: any; inputIcon: any; disabled: any; ... 4 more ...; tooltipContent: any; }} param0
 * @param {*} param0.controlId
 * @param {*} param0.label
 * @param {*} param0.placeholder
 * @param {*} param0.handleChange
 * @param {*} param0.handleBlur
 * @param {*} param0.errorsField
 * @param {*} param0.touched
 * @param {*} param0.value
 * @param {*} param0.inputClassName
 * @param {*} param0.inputWrapClass
 * @param {*} param0.inputIcon
 * @param {*} param0.disabled
 * @param {*} param0.wrapperClassname
 * @param {*} param0.keyfilter
 * @param {*} param0.validationSchema
 * @param {*} param0.tooltip
 * @param {*} param0.tooltipContent
 * @returns
 */

const CustomInputText: FC<ICustomInputText> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  inputClassName,
  inputWrapClass,
  inputIcon,
  disabled,
  wrapperClassname,
  keyfilter,
  validationSchema,
  tooltip,
  tooltipContent,
  autoComplete,
}) => {
  const isRequired = validationSchema
    ? isFieldRequired(validationSchema, controlId)
    : false;
  return (
    <Form.Group className={wrapperClassname}>
      {label && (
        <CommonFormLabel
          controlId={controlId}
          label={label}
          isRequired={isRequired}
          tooltip={tooltip}
          tooltipContent={tooltipContent}
        />
      )}
      <div
        className={`position-relative w-100 ${inputWrapClass ? inputWrapClass : ""}`}
      >
        {inputIcon ? <i>{inputIcon}</i> : ""}
        <InputText
          id={controlId}
          placeholder={placeholder}
          value={value}
          onChange={handleChange(controlId)}
          className={
            errorsField && touched
              ? `p-invalid is-invalid w-100 ${inputClassName ?? ""}`
              : `w-100 ${inputClassName ?? ""}`
          }
          onBlur={handleBlur(controlId)}
          disabled={disabled}
          keyfilter={keyfilter}
          autoComplete={autoComplete}
        />
      </div>
      <Form.Control.Feedback
        type="invalid"
        className={errorsField && touched ? "d-block" : "d-none"}
      >
        {errorsField}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default CustomInputText;
